<template>
  <v-app>
    <Navigation :all-messages="messages" />
    <AlertDialog ref="alertDialog" :show="showAlerts" :alerts="alerts" @close="$refs.alertDialog.close()" />
    <v-main ref="main" class="content content--more-pad" :style="top">            
      <v-container v-if="loaded" class="pr-md-12 pl-md-12">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>
<script>

import Navigation from '@/components/web/Navigation'
import AlertDialog from '@/components/web/dialogs/AlertDialog'
import {mapState, mapMutations } from 'vuex'
import { SET_USER, LOCK_BOTTOM_NAV, UNLOCK_BOTTOM_NAV, SET_ALERTS_SHOWN, RESET_CUSTOMER_STATE, SET_IMPERSONATED_ID} from '@/store/appMutations'    
import { APP_USER, APP_ALERTS_SHOWN, APP_IMPERSONATED_ID} from '@/store/appStates'
import { setAuthHeader } from '@/backend/axios'
import api from '@/backend/api'
import log from '@/logger'


export default {
  name:'WebLayout',
  components: { Navigation, AlertDialog},
  data() {
    return {
      alerts: [],           
      showAlert:false,
      messages:[],
      loaded:false,
      impersonated:false
    }
  },
  computed: {
    ...mapState({    
      user:state => state[APP_USER],
      hasShowedAlerts:state => state[APP_ALERTS_SHOWN],
      storedImpersonatedId:state => state[APP_IMPERSONATED_ID]
    }),
     authorized(){
      if(this.user === undefined || !(Object.keys((this.user)).length)) {        
        return false
      }
      return this.user.token !== undefined
    },
    showAlerts(){
      return this.alerts.length > 0 && !this.hasShowedAlerts
    },
    hasMessages(){
      return this.messages.filter(m=>m.type !== 1).length > 0
    },
    top(){
      if(this.hasMessages){
        const tag = this.$refs.main
        console.log('main' + tag)
        let count = this.messages.filter(m=>m.type !== 1).length
        let top =  (count * 2)
                
        return 'padding-top:'+top+'rem'
      }
      else{
        return 'top:88px'
      }
    }   
  },
  watch: {
    $route() {
      // On navigation, check if impersonated customer has changed.
      // Set loaded=false immediately (synchronously) so ReturnList unmounts
      // before any API calls are made with the old token.
      var token = this.$cookies.get('auth_token')
      if (token === undefined || token === null) return
      var jwt = JSON.parse(atob(token.split('.')[1]))
      if (jwt.impersonated !== undefined && 
          jwt.impersonated.toLowerCase() === 'true' && 
          this.storedImpersonatedId !== jwt.Id) {
        this.loaded = false
        this.checkAuth()
      }
    }
  },  
  created() {   
    this.checkAuth()
  },
  mounted(){
   // this.loadData()
  },
  methods: {
    ...mapMutations({
      setUser: SET_USER,
      lockNav:LOCK_BOTTOM_NAV,
      unlockNav: UNLOCK_BOTTOM_NAV,
      setAlertsShown: SET_ALERTS_SHOWN,
      resetCustomerState: RESET_CUSTOMER_STATE,
      setImpersonatedId: SET_IMPERSONATED_ID
    }),
    isObjectEmpty(someObject){
        return !(Object.keys(someObject).length)
    },
    checkAuth() {
      var token = this.$cookies.get('auth_token')
      var waitingForCustomerSwitch = false
      if (token !== undefined && token !== null) {
        var jwt = JSON.parse(atob(token.split('.')[1]))
        log.debug(jwt)
        if (jwt.impersonated === undefined) {
          this.impersonated = false
        } else {
          this.impersonated = (jwt.impersonated.toLowerCase() === 'true')
          if (this.storedImpersonatedId !== jwt.Id) {
            log.debug('Impersonating user with id ', jwt.Id)
            if (this.storedImpersonatedId !== undefined) {
              // ID changed — reset state and hide router-view so ReturnList remounts fresh
              log.debug('Impersonated ID changed, resetting state')
              this.resetCustomerState()
              this.alerts = []
              this.messages = []
            }
            this.loaded = false
            waitingForCustomerSwitch = true
            // Set the new token immediately so all subsequent API calls use it
            setAuthHeader(token)
            this.setImpersonatedId(jwt.Id)
          }
        }
        api.validate(token)
          .then(resp => {
            const newToken = resp.data.token
            setAuthHeader(newToken)
            log.debug('Setting token:', newToken)
            if (this.$cookies.get('auth_token') === undefined) {
              this.$cookies.set('auth_token', newToken, null, null, 'kvallstidningarna.se')
            }
            this.setUser(resp.data)
            this.loaded = true
            this.loadData()
          })
          .catch(err => {
            this.valid = false
            log.debug(err)
            if (err.response && err.response.status === 400) {
              this.message = err.response.data
            }
            this.$router.push({name:'login'})
          })
      }
      // Fast-path: show page immediately if already authorized.
      // Skip when switching impersonated customer — must wait for validate to complete.
      if (!waitingForCustomerSwitch) {
        if (!this.authorized) {
          // not authorized — catch() above will redirect to login
        } else {
          this.loaded = true
        }
      }
    },
    addAlert(title, message, force, openDialog) {
      var forceMessage = 'Detta måste göras innan ni kan påbörja er normala returrapportering.'
      if (force === true) {
        message = message + ' ' + forceMessage
      }
      this.alerts.push({ title, message, force, openDialog })
    },
    loadMessages() {
      api.getMessages().then((resp) => {
        log.debug('Messages:', resp)
        this.messages = resp.data
      })
      .catch(error => {          
        log.debug('Errors:', error)
      })
    },       
    loadData() {
      const self = this
      this.loadMessages()
      if(!this.impersonated){
        api.getAlerts().then((resp) => {
          var force = false
          resp.data.alerts.forEach(alert => {
            if (alert.remind === true) {
              if (alert.imperative === true) {
                force = true
              }
              switch(alert.alertType) {
                case 'HELGDAGAR':
                  this.addAlert('Rapportera helgdagar', 'Nu är det dags att rapportera hur ni har öppet/stängt under kommande helgdagar.', alert.imperative, 'helgsparr')
                  break
                case 'OPPETTIDER':
                  this.addAlert('Rapportera öppettider', 'Nu är det dags att rapportera era öppettider.', alert.imperative)
                  break
                case 'BESTALLBUNT':
                  this.addAlert('Beställ returetiketter', 'Dina returetiketter börjar ta slut. Vill du beställa ett nytt block med returetiketter?', alert.imperative, 'order')
                  break
                case 'BUNDLES':
                  this.addAlert('Stäng buntar', 'Du har för många öppna buntar. Stäng färdigrapporterade buntar innan du returrapporterar', alert.imperative)
                  break
                case 'LOP':
                  this.addAlert('Löpsedlar', 'Rapportera in önskat antal löpsedlar.', alert.imperative,'lopsedlar')
                  break
                default:
                  this.addAlert(alert.alertType, `AlertType[${alert.alertType}]`, alert.imperative)
              }
            }
          })
          if (force === true) {
            this.lockNav()
          } else {
            this.unlockNav()
          }
          if(self.alerts.length > 0 && !self.hasShowedAlerts){
            self.$refs.alertDialog.open()           
          }
        })
        .catch(error => {          
          log.debug('Errors:', error)
        })      
    }
    },
    
  }
}
</script>

<style lang="scss">
  @import '../sass/app.scss';
</style>

<style lang="scss" scoped>
  .v-application{
    font-family: 'AkzidenzGroteskBE'!important;
  }
</style>
